import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import Header from './header';
import styles from './Checkout.module.css';


  const token = localStorage.getItem('token');
var username = "none";

   if (token) {
 const decoded = jwtDecode(token);
 username = decoded.username;

   }

const Checkout = ({ cartList = [], cartTotal = 0, onRemoveItem = () => {}, onClearCart = () => {} }) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullname: '',
    address: '',
    city: '',
    tel1: '',
    tel2: '',
    note: '',
    paymentMethod: 'cash on delivery',
    myusername: username

  });

  const [showCartDropdown, setShowCartDropdown] = useState(false);

  const [toast, setToast] = useState({ visible: false, message: '' });

  const closeToast = () => {
    console.log('closeToast called');
    setToast({ visible: false, message: '' });
    setTimeout(() => {
      if (typeof onClearCart === 'function') {
        console.log('onClearCart is a function, calling it now');
        onClearCart();
      } else {
        console.log('onClearCart is not a function');
      }
      navigate('/');
    }, 100);
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setFormData(prev => ({
          ...prev,
          fullname: decoded.name || '',
          address: decoded.address || '',
          city: decoded.city || '',
          tel1: decoded.tel1 || '',
          tel2: decoded.tel2 || '',
           myusername: decoded.username || ''
        }));
      } catch (error) {
        // If token is invalid or decoding fails, do nothing
      }
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const showSuccessToast = (orderId) => {
    setToast({
      visible: true,
      message: `Order Placed Successfully, your Invoice number is ${orderId}`
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Get max order_id from backend
      const maxOrderIdResponse = await fetch('/api/orders/maxOrderId');
      if (!maxOrderIdResponse.ok) {
        throw new Error('Failed to fetch max order ID');
      }
      const maxOrderIdData = await maxOrderIdResponse.json();
      let orderId = maxOrderIdData.maxOrderId || 0;
      orderId += 1;

      // Get client_id from token if logged in
      let clientId = null;
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const decoded = jwtDecode(token);
          clientId = decoded.username || null;
        } catch (error) {
          clientId = null;
        }
      }

      const currentDate = new Date().toISOString();

      // Post each cart item as an order
      for (const item of cartList) {
        const price = parseFloat(item.item_price || item.sell_price || 0);
        const quantity = item.quantity || 1;
        const totalPrice = price * quantity;

        const orderData = {
          order_id: orderId,
          item_id: item.item_id || null,
          item_name: item.item_name || '',
          client_id: clientId,
          client_name: formData.fullname,
          total_price: totalPrice,
          address: formData.address,
          city: formData.city,
          date: currentDate,
          client_tel1: formData.tel1,
          client_tel2: formData.tel2,
          note: formData.note,
          paymentmethod: formData.paymentMethod,
          quantity: quantity,
          myusername: username
        };

        console.log('Posting order item:', orderData);

        const postResponse = await fetch('/api/orders', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(orderData)
        });

        console.log('Post response status:', postResponse.status);

        if (!postResponse.ok) {
          const errorText = await postResponse.text();
          console.error('Failed to post order item:', errorText);
          throw new Error('Failed to post order item');
        }
      }

      showSuccessToast(orderId);
      if (typeof onClearCart === 'function') {
        onClearCart();
      }
    } catch (error) {
      alert(`Error placing order: ${error.message}`);
    }
  };

  const handleCartToggle = () => {
    setShowCartDropdown(prev => !prev);
  };

  return (
    <>
      <Header
        cartItems={cartList.length}
        cartList={cartList}
        cartTotal={cartTotal}
        showCartDropdown={showCartDropdown}
        onCartToggle={handleCartToggle}
        onRemoveItem={onRemoveItem}
      />


       <br/>      <br/>
      <br/>
      <br/>
      <br/>
      <br/>

      
      <div className={styles.checkoutContainer}>
        <h2 className={styles.title}>Checkout</h2>
        {cartList.length === 0 ? (
          <p className={styles.emptyCart}>Your cart is empty.</p>
        ) : (
          <>
            <table className={styles.table}>
              <thead className={styles.tableHeader}>
                <tr>
                  <th>Item</th>
                  <th>Price</th>
                  <th>Quantity</th>
                  <th>Subtotal</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {cartList.map((item, index) => {
                  const price = parseFloat(item.item_price || item.sell_price || 0);
                  const quantity = item.quantity || 1;
                  const subtotal = price * quantity;
                  return (
                    <tr key={index} className={styles.tableRow}>
                      <td className={`${styles.tableCell} ${styles.productCell}`}>
                        <img 
                          src={item.photo_url} 
                          alt={item.item_name} 
                          className={styles.productImage}
                        />
                        <span className={styles.productName}>{item.item_name}</span>
                      </td>
                      <td className={styles.tableCell}>${price.toFixed(2)}</td>
                      <td className={styles.tableCell}>{quantity}</td>
                      <td className={styles.tableCell}>${subtotal.toFixed(2)}</td>
                      <td className={styles.tableCell}>
                        <button
                          onClick={() => onRemoveItem(index)}
                          className={styles.deleteButton}
                          aria-label="Delete item"
                          title="Delete item"
                        >
                          <i className="fa fa-trash" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className={styles.totalSection}>
              Total: ${cartTotal.toFixed(2)}
            </div>
            <form onSubmit={handleSubmit} className={styles.form}>
              <div className={styles.formGroup}>
                <label className={styles.label}>Full Name:</label>
                <input
                  type="text"
                  name="fullname"
                  value={formData.fullname}
                  onChange={handleChange}
                  required
                  className={styles.input}
                />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>City:</label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                  className={styles.input}
                />
              </div>
              <div className={`${styles.formGroup} ${styles.formGroupFull}`}>
                <label className={styles.label}>Address:</label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                  className={styles.input}
                />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Tel1:</label>
                <input
                  type="tel"
                  name="tel1"
                  value={formData.tel1}
                  onChange={handleChange}
                  required
                  className={styles.input}
                />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>Tel2:</label>
                <input
                  type="tel"
                  name="tel2"
                  value={formData.tel2}
                  onChange={handleChange}
                  className={styles.input}
                />
              </div>
              <div className={`${styles.formGroup} ${styles.formGroupFull}`}>
                <label className={styles.label}>Note:</label>
                <textarea
                  name="note"
                  value={formData.note}
                  onChange={handleChange}
                  rows="3"
                  className={styles.textarea}
                />
              </div>
              <div className={`${styles.formGroup} ${styles.formGroupFull}`}>
                <label className={styles.label}>Payment Method:</label>
                <select
                  name="paymentMethod"
                  value={formData.paymentMethod}
                  onChange={handleChange}
                  required
                  className={styles.select}
                >
                  <option value="cash on delivery">Cash on Delivery</option>
                  <option value="Wish Money">Wish Money</option>
                </select>
              </div>


  <div className={`${styles.formGroup} ${styles.formGroupFull}`}>
                 <input
                  name="myusername"
                  value={username}
                   hidden
                />
              </div>


              <button type="submit" className={styles.submitButton}>
                Place Order
              </button>
            </form>

                   <br/>      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
          </>
        )}
      </div>

      {/* Toast Notification */}
      {toast.visible && (
        <div className={styles.toast}>
          <span className={styles.toastMessage}>{toast.message}</span>
          <button onClick={closeToast} className={styles.toastCloseButton}>
            &times;
          </button>
        </div>
      )}
    </>
  );
};

export default Checkout;
